export enum ProductCategory {
    none = 0,
    radar = 1,
    satellite = 2,
    lightning = 3,
    airport = 4,
    airspace = 5,
    flex = 6,
    airmetsSigmets = 7,
    turbulence = 8,
    icing = 9,
    winds = 10,
    convective = 11,
    miscellaneous = 12,
    fronts = 13,
    database = 14,
    sigWx = 15
}

const categories: Array<{ id: ProductCategory; name: string; image?: string; hidden?: boolean }> = [
    { id: ProductCategory.radar, name: 'Radar', image: '/img/weather/Weather-Radar.png' },
    { id: ProductCategory.satellite, name: 'Satellite', image: '/img/weather/Weather-Satellite.png' },
    { id: ProductCategory.lightning, name: 'Lightning', image: '/img/weather/Weather-Lightning.png' },
    { id: ProductCategory.airport, name: 'Airport', image: '/img/weather/Weather-Airport.png' },
    { id: ProductCategory.airspace, name: 'Airspace', image: '/img/weather/Weather-Airspace.png' },
    { id: ProductCategory.airmetsSigmets, name: 'Airmets/Sigmets', image: '/img/weather/Weather-AMSM.png' },
    { id: ProductCategory.turbulence, name: 'Turbulence', image: '/img/weather/Weather-Turb.png' },
    { id: ProductCategory.icing, name: 'Icing', image: '/img/weather/Weather-Icing.png' },
    { id: ProductCategory.winds, name: 'Winds', image: '/img/weather/Weather-Winds.png' },
    { id: ProductCategory.convective, name: 'Convective', image: '/img/weather/Weather-Conv.png' },
    { id: ProductCategory.fronts, name: 'Fronts', image: '/img/weather/Weather-Fronts.png' },
    { id: ProductCategory.database, name: 'Database', image: '', hidden: true },
    { id: ProductCategory.sigWx, name: 'SigWx', image: '/img/weather/Weather-SigWx.png' },
    { id: ProductCategory.miscellaneous, name: 'Miscellaneous', image: '/img/weather/Weather-Misc.png' }
] as const;

export type ProductCategoryItem = (typeof categories)[0];
export default categories;
